<div class="automation-box-wrapper" *ngFor="let autoItem of automationConfigs">
    <div class="automation-box-card" (click)="onAutomationCardClick(autoItem)"
        [title]="getAutomationCardContent(autoItem)">
        <div class="automation-card-content">
            <span class="automation-line">
                <span>{{getAutomationCardContent(autoItem)}}</span>
            </span>
        </div>
        <div class="node-wrap-content-icon" (click)="onClickAutomationCardMenu($event,autoItem)">
            <smart-icon name="meatball"></smart-icon>
        </div>
    </div>
</div>
<tam-context-menu [config]="automationContextMenuConfig"></tam-context-menu>